import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  chatStore,
  freeBetStore,
  userInfoStore,
  applicationStore,
} from '@pascal/pascal-core/shared/core/store';
import {
  GameScenes,
  popupStore,
  MobileWrapper,
  TranslationKeys,
  BetNotificationWr,
  platformMessageStore,
} from '@pascal/pascal-core';

import Mobile from './mobile';
import { TKeys } from '../../enums';
import ActiveGameScene from './activeGameScene';
import { CurrentPopUpTypes } from '../../enums/uiConfig';
import { PopupsWrapper } from '../common/popUps/wrapper';
import { bonusIslandStore } from '../../store/bonusIslandStore';
import betsIcon from '../../assets/images/core/navigation/menu-bet.svg';
import gameIcon from '../../assets/images/core/navigation/menu-game.svg';
import helpIcon from '../../assets/images/core/navigation/menu-info.svg';
import chatIcon from '../../assets/images/core/navigation/menu-chat.svg';
import resultIcon from '../../assets/images/core/navigation/menu-result.svg';
import betsIconColor from '../../assets/images/core/navigation/menu-bet-color.svg';
import playForRealPopupImg from '../../assets/images/core/play-for-real-popup.png';
import helpIconColor from '../../assets/images/core/navigation/menu-info-color.svg';
import chatIconColor from '../../assets/images/core/navigation/menu-chat-color.svg';
import statisticsIcon from '../../assets/images/core/navigation/menu-statistics.svg';
import BonusIslandButton from '../../components/common/bonusIsland/bonusIslandButton';
import resultIconColor from '../../assets/images/core/navigation/menu-result-color.svg';
import statisticsIconColor from '../../assets/images/core/navigation/menu-statistics-color.svg';

export const MobileMainWrapper = observer(() => {
  const { activeFreeBet } = freeBetStore;
  const { isDemo } = applicationStore;
  const {
    isOpenBetHistorySection,
    setIsOpenBetHistorySection,
    isOpenOddsSection,
    isOpenGameHelpSection,
  } = platformMessageStore;
  const { isShowChat } = chatStore;
  const [gameScene, setGameScene] = useState(null);

  const handleGameSceneChange = (clickedScene) => {
    if (clickedScene !== GameScenes.Info) {
      if (isOpenOddsSection) {
        platformMessageStore.setIsOpenOddsSection(false);
      }

      if (isOpenGameHelpSection) {
        platformMessageStore.setIsOpenGameHelpSection(false);
      }
    }

    if (clickedScene !== GameScenes.Bets && isOpenBetHistorySection) {
      setIsOpenBetHistorySection(false);
    }

    popupStore.close();
    setGameScene(clickedScene);

    if (clickedScene === GameScenes.Info) {
      setTimeout(() => {
        popupStore.open();
      }, 0);
    }
  };

  const navItemsPropsArr = useMemo(() => {
    let navItems = [
      {
        text: TranslationKeys.Game,
        activeImageSrc: gameIcon,
        inActiveImageSrc: gameIcon,
        isActive: !gameScene,
        onClick: () => {
          handleGameSceneChange(null);
        },
        isCommon: true,
      },
      {
        text: TKeys.results,
        scene: GameScenes.Results,
        activeImageSrc: resultIconColor,
        inActiveImageSrc: resultIcon,
        isActive: gameScene === GameScenes.Results,
        onClick: () => handleGameSceneChange(GameScenes.Results),
      },
      {
        text: TranslationKeys.Bet,
        scene: GameScenes.Bets,
        activeImageSrc: betsIconColor,
        inActiveImageSrc: betsIcon,
        isActive: gameScene === GameScenes.Bets,
        isCommon: true,
        onClick: () => {
          handleGameSceneChange(GameScenes.Bets);
        },
      },
      {
        text: TKeys.STATISTICS,
        scene: GameScenes.Statistics,
        activeImageSrc: statisticsIconColor,
        inActiveImageSrc: statisticsIcon,
        isActive: gameScene === GameScenes.Statistics,
        onClick: () => {
          handleGameSceneChange(GameScenes.Statistics);
        },
      },
      {
        text: TKeys.INFO,
        scene: GameScenes.Info,
        activeImageSrc: helpIconColor,
        inActiveImageSrc: helpIcon,
        isActive: gameScene === GameScenes.Info,
        onClick: () => handleGameSceneChange(GameScenes.Info),
      },
    ];

    if (!isDemo && isShowChat) {
      navItems = [
        ...navItems,
        {
          text: TranslationKeys.Chat,
          scene: GameScenes.Chat,
          activeImageSrc: chatIconColor,
          inActiveImageSrc: chatIcon,
          isActive: gameScene === GameScenes.Chat,
          onClick: () => handleGameSceneChange(GameScenes.Chat),
        },
      ];
    }

    return navItems;
  }, [gameScene, isDemo, isShowChat]);

  return (
    <MobileWrapper
      isShowIconTag
      hasFreeBets
      haveDarkMode
      additionalChildren={
        userInfoStore.userId && bonusIslandStore.ranges && !applicationStore.isDemo ? (
          <BonusIslandButton
            onClick={() => popupStore.open({ name: CurrentPopUpTypes.BonusIsland })}
          />
        ) : null
      }
      handleGameSceneChange={handleGameSceneChange}
      navItemsPropsArr={navItemsPropsArr}
      playForRealPopupImgSrc={playForRealPopupImg}
      isShowBogLineLobby
    >
      <div className={`mobile-game_wrapper ${gameScene ? 'hidden' : ''}`}>
        <BetNotificationWr autoCashOutMinOdd={activeFreeBet?.id ? activeFreeBet?.minOdd : 1.01} />
        <Mobile />
      </div>
      {gameScene && <ActiveGameScene gameScene={gameScene} />}
      <PopupsWrapper />
    </MobileWrapper>
  );
});
